import { ClasseDefTypes } from '../classe/classe.def';
import { ID } from '../typeDef';

export interface LyceeDef {
  name: string;
  adresse: string;
  ville: string;
  codepostal: string;
  tel: string;
  academie: ID;
}

export interface CreateRespTypes {
  success: boolean;
  message: string;
  data: {
    lycee: any;
    classe: any;
  };
}

export interface CreateLyceeThenClasseTypes {
  lycee: LyceeDef;
  classe: ClasseDefTypes;
}

export const initialLyceeState: LyceeDef = {
  name: null,
  adresse: null,
  ville: null,
  codepostal: null,
  tel: null,
  academie: null
};
